/* Stops form-filling bots before Shopify emails Rich. Each guarded form has a
   hidden "Leave this empty" field (snippets/spam-guard.liquid): people never see
   it, bots fill it. A submission within a few seconds of the page opening is
   also refused. Bots that post without running this script still send the trap
   field, so their emails can be filtered on "Leave this empty". Shopify's own
   hCaptcha (Online Store → Preferences → Spam protection) covers the rest. */

export const MIN_MS = 3000;

export function spamVerdict({ trap, startedAt, now }) {
  if (String(trap || "").trim() !== "") return "trap";
  if (now - startedAt < MIN_MS) return "too-quick";
  return null;
}

if (typeof document !== "undefined") {
  const startedAt = Date.now();
  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      const trap = form.querySelector?.(".spam-guard input");
      if (!trap) return;
      const verdict = spamVerdict({ trap: trap.value, startedAt, now: Date.now() });
      if (!verdict) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (verdict === "too-quick") {
        let note = form.querySelector("[data-spam-guard-note]");
        if (!note) {
          note = document.createElement("p");
          note.className = "form-errors";
          note.setAttribute("role", "alert");
          note.dataset.spamGuardNote = "";
          form.prepend(note);
        }
        note.textContent = "That was quick. Please check your details and send again.";
      }
    },
    true,
  );
}
